import React, { useState } from "react";
import "../App.css";

function DeleteAccount() {
	const [emailRevealed, setEmailRevealed] = useState(false);

	// Email parts stored separately and encoded to avoid bot scraping
	const getEmail = () => {
		const parts = ["contact", "gymnote", "fr"];
		return parts[0] + "@" + parts[1] + "." + parts[2];
	};

	const handleRevealClick = () => {
		setEmailRevealed(true);
	};

	const handleEmailClick = (e) => {
		e.preventDefault();
		const email = getEmail();
		window.location.href = "mai" + "lto:" + email;
	};

	return (
		<div className="page">
			<div className="page-content">
				<div className="delete-account-container">
					<h1 className="delete-account-title">Supprimer mon compte GymNote</h1>

					<p className="delete-account-intro">
						Cette page vous permet de demander la suppression de votre compte
						utilisateur de l'application <strong>GymNote</strong>, développée par
						<strong> FrenchMatrix</strong>.
					</p>

					<div className="delete-account-section">
						<h2>Procédure de suppression</h2>
						<p>
							Pour supprimer définitivement votre compte GymNote et vos données
							associées, suivez ces étapes :
						</p>
						<ol className="delete-steps">
							<li>
								<strong>Envoyez un email</strong>
								<p>Cliquez sur le bouton ci-dessous pour afficher l'adresse email de contact.</p>
							</li>
							<li>
								<strong>Utilisez la même adresse email</strong>
								<p>Votre demande doit être envoyée depuis l'adresse email utilisée pour vous connecter à GymNote.</p>
							</li>
							<li>
								<strong>Indiquez votre demande</strong>
								<p>Précisez dans votre email que vous souhaitez supprimer votre compte et vos données.</p>
							</li>
						</ol>
						<p className="delete-email">
							{!emailRevealed ? (
								<button
									onClick={handleRevealClick}
									className="reveal-email-btn"
								>
									Cliquez pour afficher l'adresse email
								</button>
							) : (
								<a href="#" onClick={handleEmailClick}>
									{getEmail()}
								</a>
							)}
						</p>
						<p>
							Votre demande sera traitée dans un délai de <strong>30 jours</strong> maximum.
						</p>
					</div>

					<div className="delete-account-section">
						<h2>Données supprimées</h2>
						<p>
							Lors de la suppression de votre compte, les données suivantes seront
							<strong> définitivement effacées</strong> :
						</p>
						<ul className="delete-data-list">
							<li>Votre profil utilisateur et informations personnelles (nom, email)</li>
							<li>Votre historique complet d'entraînements</li>
							<li>Vos performances et statistiques enregistrées</li>
							<li>Vos exercices personnalisés</li>
							<li>Vos connexions et liens avec d'autres utilisateurs</li>
							<li>Vos templates et programmes d'entraînement</li>
						</ul>
					</div>

					<div className="delete-account-section">
						<h2>Données conservées</h2>
						<p>
							Certaines données peuvent être conservées pour des raisons légales ou
							de sécurité :
						</p>
						<ul className="delete-data-list">
							<li>Logs de transactions (si applicable) - conservés 10 ans conformément aux obligations légales</li>
							<li>Données anonymisées à des fins statistiques (non identifiables)</li>
						</ul>
					</div>

					<div className="delete-account-section delete-account-warning">
						<h2>Important</h2>
						<p>
							Cette action est <strong>irréversible</strong>. Une fois votre
							compte supprimé, il sera impossible de récupérer vos données.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default DeleteAccount;
